<template>
<div>

  <div class="timescale noselect">
    <div v-if="showTitle" class="title sticky top55">{{title}}</div>
    <div v-for="hour in hours" :key="hour.id" class="hourline" @click="$emit('click', hour.text)">
      <div @click.stop class="hour">{{ hour.text }}</div>
    </div>
  </div>
  <div v-if="double" class="other">
    <div v-if="showTitle" class="title sticky top55">{{title}}</div>
    <div v-for="hour in hours" :key="hour.id" class="hourline" @click="$emit('click', hour.text)">
      <div @click.stop class="hour">{{ hour.text }}</div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'TimeScale',
  props: ['title', 'double'],
  computed: {
    showTitle () {
      return this.title && this.title.length > 0;
    }
  },
  data () {
    return {
      hours: [
        // { id: 1, text: '6:00' },
        // { id: 2, text: '7:00' },
        { id: 3, text: '8:00' },
        { id: 4, text: '9:00' },
        { id: 5, text: '10:00' },
        { id: 6, text: '11:00' },
        { id: 7, text: '12:00' },
        { id: 8, text: '13:00' },
        { id: 9, text: '14:00' },
        { id: 10, text: '15:00' },
        { id: 11, text: '16:00' },
        { id: 12, text: '17:00' },
        { id: 13, text: '18:00' },
        // { id: 14, text: '19:00' },
        // { id: 15, text: '20:00' },
        // { id: 16, text: '21:00' },
        // { id: 17, text: '22:00' },
        // { id: 18, text: '23:00' },
      ],
    }
  },
}
</script>

<style lang='scss' scoped>

@import 'src/color.scss';
@import 'src/values.scss';

.timescale {
  text-align: left;
}

.title {
  height: $day-name-height;
  line-height: $day-name-height;
  width: 4em;
  text-align: center;
  border-right: 1px solid $table-border-color;
  border-bottom: 1px solid $table-border-color;
  background: white;
}

.hourline {
  box-sizing: border-box;
}

.hourline::after {
  content: "";
  width: 100%;
  border-bottom: 1px dashed $table-border-color;
  float: left;
}

.hourline:last-child::after {
  border-bottom: initial;
}

.hour {
  height: $hour-height;
  width: 20%;
  max-width: $hour-height;
  text-align: center;
  font-size: 1em;
  // line-height:  $hour-height;
  border-right: 1px solid $table-border-color;
}

.other {
  margin-top: $day-name-height;
  width: calc((100% - 4em) * 0.4 + 4em);
}

.top55 {
  top: 5.5em;
  z-index: 99;
}

</style>



// WEBPACK FOOTER //
// src/components/TimeScale.vue